import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Component/Layout";
import ScrollToTop from "./Component/ScrollToTop";

// Lazy-loaded pages
const Home = lazy(() => import("./Component/Home"));
const About = lazy(() => import("./Component/about"));
const Services = lazy(() => import("./Component/Services"));
const Products = lazy(() => import("./Component/Products"));
const Clients = lazy(() => import("./Component/Clients"));
const Contact = lazy(() => import("./Component/Contact"));
const Blog = lazy(() => import("./Component/blog"));
const Careers = lazy(() => import("./Component/Careers"));
const NotFound = lazy(() => import("./Component/NotFound"));

// Service Pages
const BillingSoftware = lazy(() => import("./Component/services/BillingSoftware"));
const WebDevelopment = lazy(() => import("./Component/services/WebDevelopment"));
const ProductDetail = lazy(() => import("./Component/ProductDetail"));

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/billing-software" element={<BillingSoftware />} />
            <Route path="/services/web-development" element={<WebDevelopment />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:productId" element={<ProductDetail />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
